export const locations = [
	"Delhi",
	"Mumbai",
	"Kolkata",
	"Hyderabad",
	"Ahemdabad",
	"Jaipur",
	"Chandigarh",
	"Pune",
	"Surat",
	"Jammu",
];
